import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cat-grid-switch"
export default class extends Controller {

  static targets = ["switch"]

  connect() {
  }

  toggle() {
    if(event.currentTarget.classList.contains('gridview')){
      this.element.classList.add('gridview');
      event.currentTarget.classList.add('active')
      this.element.querySelector('.rowview').classList.remove('active');
    } else if(event.currentTarget.classList.contains('rowview')) {
      this.element.classList.remove('gridview');
      event.currentTarget.classList.add('active')
      this.element.querySelector('.gridview').classList.remove('active');
    }
  }
}
